
function VideoBlock() {
    /*console.log("Doin' them video blocks", document.querySelectorAll('.video.youtube'));*/
    for (let youtubeVideo of document.querySelectorAll('.video.youtube')) {
        /*console.log("Video Youtube", youtubeVideo);*/
        let iframe = youtubeVideo.querySelector('iframe');
        let thumbnail = youtubeVideo.querySelector('.thumbnail');
        let playIcon = youtubeVideo.querySelector('.play-icon');
        let playIconHover = youtubeVideo.querySelector('.play-icon.hover');
        /*let videoId = new URL(iframe.getAttribute('src')).pathname.slice('/embed/'.length);
        fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
        .then(function(response) {
            return response.json();
        }).then(function(details) {
            iframe.style.setProperty('aspect-ratio', `${details.width} / ${details.height}`);
        })*/
        new YT.Player(iframe, {
            events: {
                'onReady': function(event) {
                    let player = event.target;
                    thumbnail.addEventListener('click', function() {
                        player.playVideo();
                        thumbnail.setAttribute('hidden', 'hidden');
                        playIcon.setAttribute('hidden', 'hidden');
                        playIconHover.setAttribute('hidden', 'hidden');
                    });
                },
                'onStateChange': function(event) {
                    let playerState = event.data;
                    if (playerState == 2) {
                        thumbnail.removeAttribute('hidden');
                        playIcon.removeAttribute('hidden');
                        playIconHover.removeAttribute('hidden');
                    }
                }
            }
        });
    }
}

if (typeof YT !== 'undefined' && YT.loaded) {
    VideoBlock();
}
else if (window.hasOwnProperty('onYouTubeIframeAPIReady')) {
    let onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function() {
        onYouTubeIframeAPIReady();
        VideoBlock();
    }
}
else {
    window.onYouTubeIframeAPIReady = VideoBlock;
}
